import httpClient from "./httpClient";

/**
 * File download requires the same Bearer auth header as every other API
 * call, which a plain `<img src="...">` can't send — so photos are fetched
 * as blobs and rendered via an object URL (see PhotoUpload component)
 * instead of linking `/api/files/...` directly.
 */
export function fetchFileBlobUrl(folder, fileName) {
  return httpClient
    .get(`/files/${folder}/${fileName}`, { responseType: "blob" })
    .then((res) => URL.createObjectURL(res.data));
}

export function uploadFile(folder, file) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post(`/files/${folder}`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.data.fileName);
}
